const DAY_LABELS = ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar'];

export function formatWorkingHours(schedule) {
  if (!schedule || !Array.isArray(schedule) || schedule.length !== 7) return null;

  const grouped = [];
  let i = 0;
  while (i < schedule.length) {
    const item = schedule[i];
    if (!item.open) {
      grouped.push({ days: [DAY_LABELS[i]], open: false });
      i++;
    } else {
      let j = i + 1;
      while (j < schedule.length && schedule[j].open && schedule[j].start === item.start && schedule[j].end === item.end) j++;
      const dayLabels = [];
      for (let k = i; k < j; k++) dayLabels.push(DAY_LABELS[k]);
      grouped.push({ days: dayLabels, open: true, start: item.start, end: item.end });
      i = j;
    }
  }
  return grouped;
}
